/**
 * Episode Event Bus
 *
 * Simple event bus for communication between ManageEpisodes and EditEpisode views.
 * When a job is submitted or status changes in one view, it broadcasts to all listeners.
 *
 * Events:
 * - episode:status-changed - Episode processing status changed (stitch, qc, transcode)
 * - episode:job-submitted - A job was submitted for an episode
 * - episode:files-linked - Files were linked to an episode
 *
 * Usage:
 *   import episodeEventBus from '@/services/episodeEventBus'
 *
 *   // Emit an event
 *   episodeEventBus.$emit('episode:status-changed', { episodeId: 123, status: 'queued' })
 *
 *   // Listen for events (in mounted/created)
 *   episodeEventBus.$on('episode:status-changed', this.handleStatusChange)
 *
 *   // Clean up (in beforeDestroy)
 *   episodeEventBus.$off('episode:status-changed', this.handleStatusChange)
 */

import Vue from 'vue'

const episodeEventBus = new Vue()

export default episodeEventBus

// Event types for documentation
export const EPISODE_EVENTS = {
  STATUS_CHANGED: 'episode:status-changed',
  JOB_SUBMITTED: 'episode:job-submitted',
  FILES_LINKED: 'episode:files-linked',
  REFRESH_REQUESTED: 'episode:refresh-requested'
}
